module.exports = __webpack_public_path__ + "static/media/instagram.0e84d592.png";